module.exports = __webpack_public_path__ + "static/banner-61673a86fce8adb556454d31f218b73d.jpg";